import {
  BrokerageFirmUploadDocumentsModule,
  IntermediaryPaymentMethodModule,
  StepperFooter,
  useStepperContext,
} from '@korint/folio';
import { useBrokerageFirmControllerGenerateDocumentsForSignature } from 'korint-sdk';
import { useAssertedParams } from '@folio/lib';

export function BrokerageFirmUploadDocuments() {
  const { brokerageFirmId } = useAssertedParams();
  const stepper = useStepperContext();

  const { mutateAsync: generateDocumentsForSignature, isPending } =
    useBrokerageFirmControllerGenerateDocumentsForSignature();

  return (
    <div className="flex flex-col gap-4">
      <BrokerageFirmUploadDocumentsModule
        hiddenDocumentCategories={[
          'SEPA_MANDATE',
          'DISTRIBUTION_CONTRACT',
          'INSURANCE_CONTRACT',
          'IPID',
          'NOTICE',
        ]}
      />
      <IntermediaryPaymentMethodModule showMandateSignatureButton={false} />
      <StepperFooter
        nextButtonEnabled={true}
        onNext={async () => {
          await generateDocumentsForSignature({ brokerageFirmId });

          stepper.next();
        }}
        loading={isPending}
      />
    </div>
  );
}
